import React, { createContext, useContext, useState, useCallback } from 'react';

const CodePageModalContext = createContext();

/**
 * CodePageModal context provider to manage modal state
 * Replaces the Flux-based modal state management
 */
export function CodePageModalProvider({ children }) {
  const [modalState, setModalState] = useState({
    isOpen: false,
    codeId: null
  });

  const openModal = useCallback((codeId) => {
    setModalState({
      isOpen: true,
      codeId
    });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      codeId: null
    });
  }, []);

  const value = {
    isOpen: modalState.isOpen,
    codeId: modalState.codeId,
    openModal,
    closeModal
  };

  return (
    <CodePageModalContext.Provider value={value}>
      {children}
    </CodePageModalContext.Provider>
  );
}

/**
 * Hook to use the CodePageModal context
 */
export function useCodePageModal() {
  const context = useContext(CodePageModalContext);
  if (!context) {
    throw new Error('useCodePageModal must be used within a CodePageModalProvider');
  }
  return context;
}

export default CodePageModalContext;